import React, { useState, useEffect } from "react";
import seoChanProfile from '../SeoChanProfile.png';
function AnimatedScore({ end = 92, duration = 1000 }) {
  const [score, setScore] = useState(0);

  useEffect(() => {
    let start = 0;
    const stepTime = Math.max(Math.floor(duration / end), 30);
    const timer = setInterval(() => {
      start += 1;
      setScore(start);
      if (start >= end) clearInterval(timer);
    }, stepTime);
    return () => clearInterval(timer);
  }, [end, duration]);

  return (
    <p className="text-8xl font-bold z-20  relative">{score}</p>
  );
}

function Features() {
  const [activeTab, setActiveTab] = useState("content1");
  const [loading, setLoading] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);

  const showTab = (tabId) => {
    setActiveTab(tabId);
  };

  if (loading) {
    return (
      <div className="bg-slate-100 h-full">
        <div className="container mx-auto py-12">
          <div className="text-center">
            <i className="bx bx-circle bx-burst bx-rotate-270 bx-fw"></i>Loading...
          </div>
        </div>
      </div>
    );
  }

  return (
    <section id="features" className="pb-10 bg-gradient-to-t from-slate-100 to-white">
      
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 grid-rows-1 md:grid-rows-2 gap-5 mt-10 ">
        <div className="col-span-2 rounded-lg bg-white p-10 border relative">
                  <div className="flex justify-center space-x-24">
          <div className="w-2/3 flex-col content-end">
       
          <p className="mb-2 text-2xl font-medium tracking-tight text-gray-950">Website Audit</p>
          <p className=" font-medium tracking-tight text-slate-500 leading-[1.5em] ">
            Our Website Audit tool offers an in depth look into your site’s SEO health, page quality and performance. Designed for quick, actionable insights, it’s the essential tool to help you drive more traffic and engagement.
          </p>
          
          </div>
            <div className="text-center p-10 relative w-1/3 ">
              <div className="relative">
                <div className="relative flex justify-center items-center mt-12 z-10">
                  <div
                    className="blur-md h-32 w-64 transform -translate-y-1/2
                    bg-gradient-to-t from-white  to-green-300
                                                    rounded-tl-full rounded-tr-full absolute top-5 z-[-10]"
                  ></div>

                  <p className="text-xs uppercase text-white px-5 py-2 z-20 opacity-75 relative bg-slate-900 rounded-full">
                    <i className="bx bxs-grid bx-fw"></i>Overall
                  </p>
                </div>

                <AnimatedScore />
                <p className="text-slate-500 text-sm">out of 100</p>
              </div>
            </div>
            
          </div>
		  
        </div>

        <div className="bg-white rounded-lg border relative p-10">
          <p className="mb-5 text-2xl font-medium tracking-tight text-gray-950">Rank Monitor</p>
          <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] ">Track your keyword positions on Google with daily updates and simple reports.
          </p>
          <div className="flex space-x-2 absolute bottom-0 justify-center items-end px-10">
          <div className="h-12 rounded-t-lg w-10 bg-gradient-to-b from-yellow-200 to-yellow-400">
          </div>
          <div className="h-20 rounded-t-lg w-10 bg-gradient-to-b from-yellow-200 to-yellow-400">
          </div>
          <div className="h-5 rounded-t-lg w-10 bg-gradient-to-b from-yellow-200 to-yellow-400">
          </div>
          <div className="h-14 rounded-t-lg w-10 bg-gradient-to-b from-yellow-200 to-yellow-400">
          </div>
          <div className="h-32 rounded-t-lg w-10 bg-gradient-to-b from-yellow-200 to-yellow-400">
          </div>
           <div className="h-24  rounded-t-lg w-10 bg-gradient-to-b from-yellow-200 to-yellow-400">
          </div>
          </div>
        </div>

        <div className="bg-white rounded-lg border relative">
          <p className="flex items-center mb-5 text-2xl font-medium tracking-tight text-gray-950 px-10 pt-10">Analytics <span className="bg-yellow-400 text-yellow-900 ml-2 rounded px-2 py-1 text-sm">new</span></p>
          <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-10 pb-10">
            Track pageviews, clicks and events without cookies, privacy-friendly and fully compliant.</p>
            <div className="absolute left-10 right-0 bottom-0 ">
            <div className="ml-10 border rounded-tl-lg border-r-0 border-b-0 py-1 border bg-slate-50" ></div>
             <div className="ml-5 border rounded-tl-lg border-r-0 border-b-0 py-1 border bg-slate-50" ></div>
                                       
            <div className="border border-b-0 border-r-0   border-slate-300 pt-10 rounded-tl-lg">
           <h3 className="text-xl font-semibold mb-4 flex items-center pl-10">
                Sources
                <span id="tip-sources" className="ml-2 text-slate-400">
                  <i className="bx bx-info-circle" />
                </span>
               
              </h3>
                          
            <li className="flex justify-between text-slate-800  border-b  last:border-0 py-3 px-10">
                      <span className="flex items-center space-x-2">
                        <img src="https://www.google.com/s2/favicons?domain=https://www.google.com" alt="logo" className="w-4 h-4" />
                        <span className="truncate max-w-[300px]">google.com</span>
                      </span>
                      <span>23</span>
                    </li>
                    <li className="flex justify-between text-slate-800 border-b last:border-0 py-3 px-10">
                      <span className="flex items-center space-x-2">
                        <img src="https://www.google.com/s2/favicons?domain=https://www.chatgpt.com" alt="logo" className="w-4 h-4" />
                        <span className="truncate max-w-[300px]">chatgpt.com</span>
                      </span>
                      <span>56</span>
                    </li>

          </div>
            </div>
        </div>
        
        <div className="bg-white rounded-lg border">
        
        <div className="relative border rounded-l-lg mt-10 ml-5  px-5 border-r-0 py-5 border-slate-300" >
                                        <p className="text-xl text-yellow-500">
                                         Title
                                        </p>
                                        <p className="text-slate-500 text-xs mb-2 uppercase">
                                          Difficulty: Low
                                        </p>
                                      Increase the title length to 50-60 characters.
                                        
                                      </div>
                                      <div className="relative ml-8 border rounded-bl-lg border-r-0 border-t-0 py-1 border bg-slate-50" ></div>
                                       <div className="mb-10 relative ml-10 border rounded-bl-lg mb-10 border-r-0 border-t-0 py-1 border bg-slate-50" ></div>

        
          <p className="mb-5 text-2xl font-medium tracking-tight text-gray-950 px-10">Quick Improvements</p>
          <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]  px-10 pb-10">
            Get prioritized recommendations to boost SEO, content and speed.</p>
        </div>


<div className="bg-white rounded-lg border relative overflow-hidden">
          <p className="flex items-center mb-5 text-2xl font-medium tracking-tight text-gray-950 px-10 pt-10">AI Visibility <span className="bg-green-400 text-green-900 ml-2 rounded px-2 py-1 text-sm">soon</span></p>
          <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-10">
            See how your content appears in AI Overviews and get insights to optimize for better AI search exposure.</p>
            <div className="flex -space-x-[1px] absolute bottom-10 justify-center w-full">
            <div className="rounded-xl p-2 border border-slate-200">
             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="60" height="60" color="#ffffff" fill="none">
    <defs />
    <path fill="#ffffff" d="M6.347,5.67 C6.933,3.696 8.789,2.25 10.982,2.25 C12.448,2.25 13.828,2.906 14.742,4.021 C16.774,3.528 18.982,4.384 20.081,6.251 C20.823,7.513 20.934,9.006 20.408,10.343 C20.97,10.917 21.377,11.627 21.59,12.421 C21.918,13.643 21.743,14.919 21.1,16.013 C20.36,17.271 19.098,18.111 17.657,18.328 C17.072,20.303 15.216,21.75 13.022,21.75 L13.021,21.75 C11.546,21.75 10.172,21.095 9.26,19.977 C8.88,20.069 8.493,20.114 8.109,20.114 L8.108,20.113 C6.44,20.113 4.815,19.263 3.921,17.746 C3.179,16.486 3.067,14.992 3.594,13.655 C3.032,13.08 2.624,12.371 2.412,11.577 C2.084,10.355 2.258,9.079 2.902,7.985 C3.643,6.726 4.906,5.886 6.347,5.67 Z M7.656,11.57 L8.704,12.187 L8.704,7.668 C8.703,7.398 8.848,7.148 9.083,7.015 L13.273,4.642 C12.66,4.074 11.843,3.749 10.983,3.749 C9.148,3.749 7.656,5.207 7.656,6.999 Z M10.729,19.357 C11.341,19.926 12.155,20.25 13.021,20.25 C14.856,20.25 16.348,18.792 16.348,17 L16.348,12.429 L15.377,11.858 L15.3,16.343 C15.295,16.609 15.151,16.852 14.92,16.983 Z M10.429,14.945 L6.525,12.646 C6.296,12.511 6.155,12.265 6.155,12 L6.155,7.243 C5.335,7.473 4.632,8.004 4.195,8.746 C3.757,9.49 3.638,10.358 3.861,11.189 C4.087,12.034 4.638,12.74 5.41,13.177 L9.461,15.472 Z M17.479,11.354 C17.708,11.489 17.849,11.735 17.849,12 L17.849,16.755 C18.668,16.524 19.37,15.994 19.807,15.252 C20.245,14.507 20.364,13.64 20.141,12.809 C19.915,11.964 19.364,11.258 18.592,10.821 L14.541,8.526 L13.571,9.054 Z M4.866,14.593 C4.663,15.395 4.78,16.249 5.214,16.985 C6.131,18.544 8.174,19.078 9.767,18.177 L13.807,15.888 L13.825,14.802 L9.812,16.988 C9.7,17.049 9.578,17.079 9.454,17.079 L9.453,17.079 C9.325,17.079 9.199,17.046 9.084,16.982 Z M10.204,8.105 L10.204,9.181 L14.19,7.01 C14.418,6.886 14.693,6.888 14.918,7.016 L19.138,9.406 C19.34,8.604 19.223,7.75 18.789,7.012 C17.872,5.453 15.829,4.919 14.236,5.821 Z M13.855,13.079 L13.891,10.983 L12.035,9.891 L10.204,10.888 L10.204,13.07 L11.967,14.108 Z" />
</svg>
            </div>
            
            <div className="rounded-xl p-2 border border-slate-300">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="60" height="60" color="#b3b3b3" fill="none">
    <defs />
    <path fill="#141B34" d="M6.347,5.67 C6.933,3.696 8.789,2.25 10.982,2.25 C12.448,2.25 13.828,2.906 14.742,4.021 C16.774,3.528 18.982,4.384 20.081,6.251 C20.823,7.513 20.934,9.006 20.408,10.343 C20.97,10.917 21.377,11.627 21.59,12.421 C21.918,13.643 21.743,14.919 21.1,16.013 C20.36,17.271 19.098,18.111 17.657,18.328 C17.072,20.303 15.216,21.75 13.022,21.75 L13.021,21.75 C11.546,21.75 10.172,21.095 9.26,19.977 C8.88,20.069 8.493,20.114 8.109,20.114 L8.108,20.113 C6.44,20.113 4.815,19.263 3.921,17.746 C3.179,16.486 3.067,14.992 3.594,13.655 C3.032,13.08 2.624,12.371 2.412,11.577 C2.084,10.355 2.258,9.079 2.902,7.985 C3.643,6.726 4.906,5.886 6.347,5.67 Z M7.656,11.57 L8.704,12.187 L8.704,7.668 C8.703,7.398 8.848,7.148 9.083,7.015 L13.273,4.642 C12.66,4.074 11.843,3.749 10.983,3.749 C9.148,3.749 7.656,5.207 7.656,6.999 Z M10.729,19.357 C11.341,19.926 12.155,20.25 13.021,20.25 C14.856,20.25 16.348,18.792 16.348,17 L16.348,12.429 L15.377,11.858 L15.3,16.343 C15.295,16.609 15.151,16.852 14.92,16.983 Z M10.429,14.945 L6.525,12.646 C6.296,12.511 6.155,12.265 6.155,12 L6.155,7.243 C5.335,7.473 4.632,8.004 4.195,8.746 C3.757,9.49 3.638,10.358 3.861,11.189 C4.087,12.034 4.638,12.74 5.41,13.177 L9.461,15.472 Z M17.479,11.354 C17.708,11.489 17.849,11.735 17.849,12 L17.849,16.755 C18.668,16.524 19.37,15.994 19.807,15.252 C20.245,14.507 20.364,13.64 20.141,12.809 C19.915,11.964 19.364,11.258 18.592,10.821 L14.541,8.526 L13.571,9.054 Z M4.866,14.593 C4.663,15.395 4.78,16.249 5.214,16.985 C6.131,18.544 8.174,19.078 9.767,18.177 L13.807,15.888 L13.825,14.802 L9.812,16.988 C9.7,17.049 9.578,17.079 9.454,17.079 L9.453,17.079 C9.325,17.079 9.199,17.046 9.084,16.982 Z M10.204,8.105 L10.204,9.181 L14.19,7.01 C14.418,6.886 14.693,6.888 14.918,7.016 L19.138,9.406 C19.34,8.604 19.223,7.75 18.789,7.012 C17.872,5.453 15.829,4.919 14.236,5.821 Z M13.855,13.079 L13.891,10.983 L12.035,9.891 L10.204,10.888 L10.204,13.07 L11.967,14.108 Z" />
</svg>
            </div>
            
            <div className="rounded-xl p-2 border border-slate-300">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="60" height="60" color="#b3b3b3" fill="none">
    <defs />
    <path fill="#141B34" d="M12,2.25 C12.414,2.25 12.75,2.586 12.75,3 C12.75,7.556 16.444,11.25 21,11.25 C21.414,11.25 21.75,11.586 21.75,12 C21.75,12.414 21.414,12.75 21,12.75 C16.444,12.75 12.75,16.444 12.75,21 C12.75,21.414 12.414,21.75 12,21.75 C11.586,21.75 11.25,21.414 11.25,21 C11.25,16.444 7.556,12.75 3,12.75 C2.586,12.75 2.25,12.414 2.25,12 C2.25,11.586 2.586,11.25 3,11.25 C7.556,11.25 11.25,7.556 11.25,3 C11.25,2.586 11.586,2.25 12,2.25 Z M12,6.757 C11.012,9.12 9.12,11.012 6.757,12 C9.12,12.988 11.012,14.88 12,17.243 C12.988,14.88 14.88,12.988 17.243,12 C14.88,11.012 12.988,9.12 12,6.757 Z" />
</svg>            </div>


<div className="rounded-xl p-2 border border-slate-300">
           <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="60" height="60" color="#b3b3b3" fill="none">
    <path d="M12.7988 23.0728C12.3888 23.0728 12.0488 22.7328 12.0488 22.3228V17.7577L8.55908 21.5931C8.25908 21.9031 7.88913 22.0631 7.47913 22.0631C6.68913 22.0631 6.03906 21.4131 6.03906 20.6231V17.0692C4.93478 17.0527 4.25369 16.9576 3.70886 16.4128C3.04886 15.7528 3.04883 14.8928 3.04883 13.3228V11.3228C3.04883 9.75275 3.04886 8.89279 3.70886 8.23279C4.06859 7.87306 4.48771 7.70939 5.04883 7.63492V3.03278C5.04883 2.23278 5.70879 1.57275 6.50879 1.57275C6.88879 1.57275 7.24881 1.72279 7.52881 1.98279L12.0488 6.51056V2.32275C12.0488 1.91275 12.3888 1.57275 12.7988 1.57275C13.2088 1.57275 13.5488 1.91275 13.5488 2.32275V6.51225L18.0583 2.00281C18.3483 1.72281 18.7183 1.57275 19.0884 1.57275C19.8883 1.57275 20.5483 2.22278 20.5483 3.03278V7.63485C21.1097 7.70929 21.529 7.87295 21.8888 8.23279C22.5488 8.89279 22.5488 9.75275 22.5488 11.3228V13.3228C22.5488 14.8928 22.5488 15.7528 21.8888 16.4128C21.3391 16.9624 20.6508 17.0543 19.5291 17.0697V20.6231C19.5291 21.4231 18.8791 22.0631 18.0891 22.0631L18.1091 22.0731C17.7091 22.0731 17.3291 21.9131 17.0491 21.6131L13.5488 17.7587V22.3228C13.5488 22.7328 13.2088 23.0728 12.7988 23.0728ZM12.0488 15.5433V10.0413L7.95911 13.7931C7.69911 14.0331 7.54907 14.3731 7.54907 14.7131V20.4931L12.0488 15.5433ZM13.5488 10.0409V15.5427L18.0491 20.4931V16.3418C18.0489 16.3354 18.0488 16.3291 18.0488 16.3228C18.0488 16.3164 18.0489 16.3101 18.0491 16.3037V14.7131C18.0491 14.3631 17.899 14.0331 17.639 13.7931L13.5488 10.0409ZM19.5291 15.5696C20.2106 15.5597 20.6626 15.5191 20.8289 15.3528C21.0488 15.1328 21.0488 14.4125 21.0488 13.3228V11.3223C21.0488 10.2326 21.0488 9.51276 20.8289 9.29279C20.6089 9.07279 19.8888 9.07275 18.7988 9.07275H14.727L18.639 12.6631C19.209 13.1931 19.5291 13.9231 19.5291 14.6931V15.5696ZM10.8411 9.07275H6.79883C5.70883 9.07275 4.9888 9.07279 4.7688 9.29279C4.54883 9.51276 4.54883 10.2326 4.54883 11.3223V13.3228C4.54883 14.4125 4.54883 15.1328 4.7688 15.3528C4.93268 15.5167 5.37402 15.5585 6.03906 15.5691V14.6931C6.03906 13.9331 6.36908 13.1931 6.92908 12.6631L10.8411 9.07275ZM18.7988 7.57275L19.0483 7.57286V3.03278L14.5864 7.57275H18.7988ZM10.9888 7.57275L6.47888 3.06281L6.53886 7.57287L6.79883 7.57275H10.9888Z" fill="#141B34" />
</svg>         </div>


<div className="rounded-xl p-2 border border-slate-300">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="60" height="60" color="#b3b3b3" fill="none">
    <path d="M11.5148 21.7578C11.5148 21.7578 11.4448 21.7578 11.4048 21.7578C10.9948 21.6978 10.7148 21.3178 10.7748 20.9078L11.6148 15.2378L7.60483 20.4678C7.35483 20.7978 6.88478 20.8578 6.55478 20.6078C6.22478 20.3578 6.16483 19.8878 6.41483 19.5578L10.3248 14.4478L5.24479 17.5178C4.89479 17.7278 4.43482 17.6178 4.21482 17.2678C4.00482 16.9178 4.11482 16.4478 4.46482 16.2378L9.6348 13.1078L2.96482 12.7578C2.55482 12.7378 2.2348 12.3778 2.2548 11.9678C2.2748 11.5578 2.60483 11.2378 3.04483 11.2578L10.1548 11.6278L4.05478 7.32781C3.71478 7.08781 3.63479 6.61783 3.87479 6.28783C4.11479 5.94783 4.58483 5.86778 4.91483 6.10778L10.6348 10.1378L6.97483 3.35778C6.77483 2.99778 6.91481 2.53782 7.27481 2.33782C7.63481 2.13782 8.09483 2.27781 8.29483 2.63781L12.0548 9.59783L12.9348 2.89782C12.9848 2.48782 13.3648 2.19779 13.7748 2.24779C14.1848 2.29779 14.4748 2.67782 14.4248 3.08782L13.4948 10.1378L17.9048 4.52782C18.1648 4.19782 18.6348 4.14782 18.9548 4.39782C19.2848 4.65782 19.3348 5.1278 19.0848 5.4478L14.5648 11.1978L20.8348 9.82781C21.2348 9.73781 21.6348 9.99782 21.7248 10.3978C21.8148 10.7978 21.5548 11.1978 21.1548 11.2878L16.1248 12.3878L21.1248 13.2378C21.5348 13.3078 21.8048 13.6978 21.7348 14.1078C21.6648 14.5178 21.2748 14.7878 20.8648 14.7178L15.3948 13.7878L19.8348 17.6178C20.1448 17.8878 20.1848 18.3578 19.9148 18.6778C19.6448 18.9978 19.1748 19.0278 18.8548 18.7578L15.0948 15.5078L17.4048 19.2278C17.6248 19.5778 17.5148 20.0378 17.1648 20.2578C16.8148 20.4778 16.3548 20.3678 16.1348 20.0178L13.1148 15.1578L12.2348 21.0878C12.1748 21.4578 11.8548 21.7278 11.4948 21.7278L11.5148 21.7578Z" fill="#141B34" />
</svg></div>


            <div className="rounded-xl p-2 border border-slate-200">
             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="60" height="60" color="#ffffff" fill="none">
    <defs />
    <path fill="#ffffff" d="M6.347,5.67 C6.933,3.696 8.789,2.25 10.982,2.25 C12.448,2.25 13.828,2.906 14.742,4.021 C16.774,3.528 18.982,4.384 20.081,6.251 C20.823,7.513 20.934,9.006 20.408,10.343 C20.97,10.917 21.377,11.627 21.59,12.421 C21.918,13.643 21.743,14.919 21.1,16.013 C20.36,17.271 19.098,18.111 17.657,18.328 C17.072,20.303 15.216,21.75 13.022,21.75 L13.021,21.75 C11.546,21.75 10.172,21.095 9.26,19.977 C8.88,20.069 8.493,20.114 8.109,20.114 L8.108,20.113 C6.44,20.113 4.815,19.263 3.921,17.746 C3.179,16.486 3.067,14.992 3.594,13.655 C3.032,13.08 2.624,12.371 2.412,11.577 C2.084,10.355 2.258,9.079 2.902,7.985 C3.643,6.726 4.906,5.886 6.347,5.67 Z M7.656,11.57 L8.704,12.187 L8.704,7.668 C8.703,7.398 8.848,7.148 9.083,7.015 L13.273,4.642 C12.66,4.074 11.843,3.749 10.983,3.749 C9.148,3.749 7.656,5.207 7.656,6.999 Z M10.729,19.357 C11.341,19.926 12.155,20.25 13.021,20.25 C14.856,20.25 16.348,18.792 16.348,17 L16.348,12.429 L15.377,11.858 L15.3,16.343 C15.295,16.609 15.151,16.852 14.92,16.983 Z M10.429,14.945 L6.525,12.646 C6.296,12.511 6.155,12.265 6.155,12 L6.155,7.243 C5.335,7.473 4.632,8.004 4.195,8.746 C3.757,9.49 3.638,10.358 3.861,11.189 C4.087,12.034 4.638,12.74 5.41,13.177 L9.461,15.472 Z M17.479,11.354 C17.708,11.489 17.849,11.735 17.849,12 L17.849,16.755 C18.668,16.524 19.37,15.994 19.807,15.252 C20.245,14.507 20.364,13.64 20.141,12.809 C19.915,11.964 19.364,11.258 18.592,10.821 L14.541,8.526 L13.571,9.054 Z M4.866,14.593 C4.663,15.395 4.78,16.249 5.214,16.985 C6.131,18.544 8.174,19.078 9.767,18.177 L13.807,15.888 L13.825,14.802 L9.812,16.988 C9.7,17.049 9.578,17.079 9.454,17.079 L9.453,17.079 C9.325,17.079 9.199,17.046 9.084,16.982 Z M10.204,8.105 L10.204,9.181 L14.19,7.01 C14.418,6.886 14.693,6.888 14.918,7.016 L19.138,9.406 C19.34,8.604 19.223,7.75 18.789,7.012 C17.872,5.453 15.829,4.919 14.236,5.821 Z M13.855,13.079 L13.891,10.983 L12.035,9.891 L10.204,10.888 L10.204,13.07 L11.967,14.108 Z" />
</svg>
            </div>
          </div>
          
          
          
        </div>
        
        
        <div className="rounded-lg bg-white border relative p-10 overflow-hidden">
        <p className="mb-5 text-2xl font-medium tracking-tight text-gray-950">Made for Small Business</p>
          <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] ">
            No complex dashboards. Just simple SEO tools designed for startups, local shops and solo founders.</p>
            <div className="flex items-center relative justify-center mt-32 mb-10">
             <div className="absolute rounded-full border border-yellow-100 p-44 mt-28 ml-40 animate-pulse duration-300">
            </div>
            <div className="absolute rounded-full border border-yellow-200 p-36 mt-28 ml-40 animate-pulse duration-300">
            </div>
            <div className="absolute rounded-full border border-yellow-300 p-28 mt-28 ml-40 animate-pulse duration-300">
            </div>
             <div className="absolute rounded-full border border-yellow-400 p-20 mt-28 ml-40 animate-pulse duration-300">
            </div>
             <div className="absolute rounded-full border border-yellow-500 p-5 mt-28 text-green-500 ml-40 animate-pulse duration-300">
             <i class='bx bxs-check-circle bx-lg' ></i>
            </div>
            </div>

        </div>
        
        <div className="col-span-2 rounded-lg bg-white border relative overflow-hidden">
             <p className="mb-5 text-2xl font-medium tracking-tight text-gray-950  px-10 pt-10">Backlink Monitor</p>
             <p className="font-medium tracking-tight text-slate-500 leading-[1.5em]   px-10 pb-20">
            Track active backlinks and monitor their quality to strengthen your SEO performance.</p>
             
            <div className="ml-10 border rounded-tl-lg border-r-0 border-b-0 absolute left-0 bottom-0 border-slate-300 w-full">
            
            <h3 className="text-xl w-full px-10 py-5">
                <i className="bx bx-list-ol bx-fw"></i> Back Link Lists{' '}
                <i id="backlink" className="bx bxs-help-circle bx-xs text-slate-300 hover:text-slate-500"></i>
                              </h3>
                              
                              <table className="min-w-full">
                <thead>
                  <tr className="bg-slate-50 text-sm border-b border-slate-100 text-slate-500">
                    <th className="py-3 px-10 font-normal text-left">Source</th>
                    <th className="py-3 px-10 font-normal text-left">Target</th>
                    <th className="py-3 px-10 font-normal text-left">DA</th>
                    <th className="py-3 px-10 font-normal text-left">PA</th>
                </tr>
                </thead>
                <tbody>
                 
                      <tr className="border-y border-slate-100 first:border-none hover:bg-yellow-50"
                      >
                        {/* Source (Page URL / Title) */}  <td className="py-5 px-10">
                          <div className="flex items-center">
                            <img src="https://www.google.com/s2/favicons?domain=https://www.pixelliongroup.com" alt="Favicon" className="w-5 h-5 mr-2 rounded" />
                            <p>
                             10 SEO Tools for small business 
                            </p>
                          </div>
                          <spam
                          
						   className="flex items-center text-slate-500 hover:text-yellow-500 text-sm"
                          >
                        https://www.pixelliongroup.com/blog/10-S...
                            <i className="bx bx-link-external ml-1"></i>
                          </spam>
                        </td>

                        {/* Target (Anchor / Destination) */}
                        <td className="py-5 px-10">
                          <p>
                            Seotic - SEO Tool
                          </p>
                          <spam className="flex items-center text-slate-500 text-sm hover:text-yellow-500"  >
                           https://www.seotic.co
                            <i className="bx bx-link-external ml-1"></i>
                          </spam>
                        </td>

                        {/* Domain Authority / Page Authority */}
                        <td className="py-5 px-10">90</td>
                        <td className="py-5 px-10">89</td>
                      </tr>
           
                </tbody>
              </table>
                              
                                          </div>
      

       </div>
       
        <div className="col-span-2 rounded-lg bg-white border relative overflow-hidden px-10 pt-10 ">
	           <p className="flex items-center mb-5 text-2xl font-medium tracking-tight text-gray-950">SeoChan <span className="bg-slate-200 text-green-900 ml-2 rounded px-2 py-1 text-sm">beta</span></p>
          <p className="font-medium tracking-tight text-slate-500 mb-10 leading-[1.5em] ">SeoChan lives inside the <span className="font-semibold text-yellow-500">Seotic</span> platform. She understands your workspace and gives contextual advice while you audit sites, research keywords or build content.
          </p>

	          <div className="border-slate-300 flex flex-col items-center justify-center bg-white text-center text-slate-500 border border-b-0 pt-8
	              pb-5 px-5 rounded-t-lg">
                <img
                  src={seoChanProfile}
                  alt="SeoChan"
                  className="w-14 h-14 rounded-lg mb-3 border border-slate-200 shadow-sm"
                />
                <h2 className="text-lg font-medium text-slate-700">
                  Hello, I’m SeoChan
                </h2>
                <p className="max-w-sm text-sm mt-1">
                  Your SEO assistant inside Seotic. Ask me about rankings, backlinks, content or anything SEO related.
                </p>
			</div>
          </div>

       

                   <div className="rounded-lg bg-white border relative overflow-hidden">
        <p className="mb-5 text-2xl font-medium tracking-tight text-gray-950 px-10 pt-10">Tasks Manager</p>
          <p className="font-medium tracking-tight text-slate-500 leading-[1.5em] px-10">
            Organize your workflow, manage your to-do lists, and keep projects moving forward with ease.</p>
            
                  <ul class="ml-10 mt-10 flex flex-col border border-r-0 border-slate-300 rounded-l-lg divide-y divide-slate-300 ">


      <li class="flex flex-col p-4">
        <div class="flex justify-between items-start sm:items-center gap-4">
         
          <label class="flex items-center space-x-2 cursor-pointer select-none">
            <div class="relative">
              <div class="w-6 h-6 rounded-full border flex items-center justify-center transition duration-200 bg-yellow-400 border-yellow-400">
        
                <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <span class="text-md transition-all duration-150 line-through text-slate-500">
              <div class="text-slate-800">Build Quality Backlinks</div>
            </span>
          </label>

        </div>
      </li>


      <li class="flex flex-col p-4">
        <div class="flex justify-between items-start sm:items-center gap-4">
          <label class="flex items-center space-x-2 cursor-pointer select-none">
            <div class="relative">
              <div class="w-6 h-6 rounded-full border flex items-center justify-center transition duration-200 border-slate-300">
        
                <svg class="w-5 h-5 text-yellow-400" fill="none" stroke="currentColor" stroke-width="4" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 12h12" />
                </svg>
              </div>
            </div>
            <span class="text-md transition-all duration-150 text-slate-500">
              <div class="text-slate-800">Conduct a Keyword Audit</div>
            </span>
          </label>
        </div>
      </li>


      <li class="flex flex-col p-4">
        <div class="flex justify-between items-start sm:items-center gap-4">
          <label class="flex items-center space-x-2 cursor-pointer select-none">
            <div class="relative">
              <div class="w-6 h-6 rounded-full border flex items-center justify-center transition duration-200 border-slate-300">
             
              </div>
            </div>
            <span class="text-md transition-all duration-150  text-slate-500">
              <div class="text-slate-800">Fix Technical SEO Issues</div>
            </span>
          </label>

     </div>
      </li>

    </ul>
            

        </div>
  
            
                 </div>
    </section>
  );
}

export default Features;